/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { useEffect, useState } from "react";
import useAPIHandler from "../../../../hook/use-api-handler";
import { logger } from "../../../../utils/logger";

const useLeaveRequestService = ({openSnackbar})=>{
    const [leaveRequestLists, setLeaveRequestLists] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [leaveDetails, setLeaveDetails] = useState([]);

    const { fetchData } = useAPIHandler();

    useEffect(() => {
        getLeaveRequestLists();
    }, [rowsPerPage, currentPage, searchQuery]);

    // logger.log("Leave Request Lists", leaveRequestLists);


    const  getLeaveRequestLists = async () =>{
        try {
            const URL = `/employee/requested-leave?page=${currentPage + 1}&pageSize=${rowsPerPage}&search=${searchQuery}`;
            const METHOD = "GET";

            const result = await fetchData({ url: URL, method: METHOD });

            setLeaveRequestLists(result?.data?.leaveRequest || []);
            const totalPageCount = result?.data?.pagination?.totalPages || 1;
            setTotalPages(totalPageCount);
        } catch (error) {
            logger.log(error);
            openSnackbar({ message: "Error fetching leave reruest", color: "danger" });
        }
    }

    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
    };

    const getEmployeeRequestLeaveInformation = async (id) => {
        try {
            const URL = `/employee/requested-leave/${id}`;
            const METHOD = "GET";
    
            const result = await fetchData({ url: URL, method: METHOD });
            setLeaveDetails(result.data[0]?.leave_request_details)
            return result.data[0];
        } catch (error) {
            logger.log(error);
            openSnackbar({ message: "Error fetching employee leave information", color: "danger" });
            return null; // Return null in case of error
        }
    };

    const handleAddRow = () => {
        setLeaveDetails([
          ...leaveDetails,
          {
            request_detail_id: null,
            leave_type_id: null,
            start_date: "",
            end_date: "",
            leave_days: 0,
          },
        ]);
      };
    
      const handleDeleteRow = (index) => {
        const updatedDetails = leaveDetails.filter((_, i) => i !== index);
        setLeaveDetails(updatedDetails);
      };
    
      const handleInputChange = (index, field, value) => {
        const updatedDetails = leaveDetails.map((detail, i) =>
          i === index ? { ...detail, [field]: value } : detail
        );
        setLeaveDetails(updatedDetails);
      };

    return{
        handleNextPage,
        leaveRequestLists,
        handlePreviousPage,
        handleRowsPerPageChange,
        setSearchQuery,
        rowsPerPage,
        currentPage,
        totalPages,
        searchQuery,
        getEmployeeRequestLeaveInformation,
        leaveDetails,
        handleAddRow,
        handleDeleteRow,
        handleInputChange
    }
}

export default useLeaveRequestService;